import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class ConfirmationDisplayMyAccount extends Component {
	render() {
		return (
			<div className="text-center">
				<div className="pp_guest_btn_wrapper">
					<a
						href="/myaccount"
						onClick={this.props.handleMyAccount}
						className="ppvx_btn ppvx_btn--secondary btn-wide"
					>{this.props.myAccount}</a>
				</div>
			</div>
		);
	}
}

export default ConfirmationDisplayMyAccount;

ConfirmationDisplayMyAccount.propTypes = {
	handleMyAccount: PropTypes.func,
	myAccount: PropTypes.string
}
